(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-features"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFeaturesAnimation(section) {
    if (!section || !section.classList.contains('section-features--animate')) return;
    var items = section.querySelectorAll('.section-features__col');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function(item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function(item, index) {
      item.style.transitionDelay = (index * 0.08) + 's';
      observer.observe(item);
    });
  }

  document.querySelectorAll('.section-features').forEach(initFeaturesAnimation);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.section-features');
    if (section) initFeaturesAnimation(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
